<template>
    <div class="mr-2">
        <button class="btn btn-primary my-auto" v-on:click="productFormShow">
            <slot></slot>
        </button>
        <modal ref="productForm" name="Product Form" dialogClass="modal-lg">
            <template v-slot:default>
                <form>
                    <div class="form-group row">
                        <label for="product-name" class="col-sm-2 col-form-label">Name</label>
                        <div class="col-sm-8">
                            <input type="text" v-model="product.name" class="form-control" id="product-name"
                                aria-describedby="nameHelp" required>
                            <small id="nameHelp" class="d-none form-text text-muted">
                                We'll never share your email with anyone else.
                            </small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="product-category-id" class="col-sm-2 col-form-label">Category</label>
                        <div class="col-sm-8">
                            <select2 v-model="product.category_id" class="form-control w-100" id="product-category-id"
                                placeholder="choose category" required>
                                <option value="0">Root</option>
                                <option v-for="(category, index) in categories" :key="index" :value="category.id">{{
                                        category.fullname
                                }}</option>
                            </select2>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="product-price" class="col-sm-2 col-form-label">Price</label>
                        <div class="col-sm-8">
                            <input v-model="product.price" type="number" min="0" class="form-control" id="product-price"
                                required>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="product-image-real" class="col-sm-2 col-form-label">Image</label>
                        <div class="col-sm-8">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="product-image-real" ref="inputFile"
                                    @change="fileChange" required>
                                <label class="custom-file-label" ref="productImage" for="product-image-real">Choose
                                    file</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="product-description" class="col-sm-2 col-form-label">Description</label>
                        <div class="col-sm-8">
                            <vue-editor v-model="product.description" id="product-description" rows="3"
                                style="resize: none;" required>
                            </vue-editor>
                        </div>
                    </div>
                    <div class="form-group">
                    </div>
                    <fieldset class="form-group row">
                        <legend class="col-form-label col-sm-2 float-sm-left pt-0">Fields</legend>
                        <button type="button" class="btn btn-primary" @click.prevent="addField">Add Field</button>
                        <product-field v-for="(field, index) in product.fields" :key="index"
                            v-model="product.fields[index]" @remove="removeField(index)"></product-field>
                    </fieldset>
                </form>
            </template>
            <template v-slot:footer>
                <button @click.prevent="saveProduct" type="submit" class="btn btn-primary">Submit</button>
            </template>
        </modal>
    </div>
</template>
<script>
import VueEditor from 'vue2-editor';
import axios from 'axios';

import uuid from '../../library/uuid';
import translator from '../../library/data-translator';
import ApiBase from '../components/ApiBase';

export default {
    extends: ApiBase,
    props: {
        value: {
            default: () => {
                return {};
            }
        },
        product_id: {
            default: null
        },
        categories: {
            default: () => { return [] }
        }
    },
    watch: {
        value: {
            deep: true,
            handler(new_value, old_value) {
                this.product = this.loadProduct(new_value);
            }
        }
    },
    data() {
        return {
            uuid: uuid(),
            category_id: null,
            product: this.newProduct()
        };
    },
    mounted() {
        var component = this;
        this.$el.querySelectorAll('[id],[for]').forEach((dom) => {
            if (dom.hasAttribute('for')) dom.setAttribute('for', dom.getAttribute('for') + '-' + component.uuid);
            if (dom.hasAttribute('id')) dom.setAttribute('id', dom.getAttribute('id') + '-' + component.uuid);
        });
    },
    methods: {
        saveProduct() {
            let request_url = `${base_url}/admin/api/products` + (this.product_id ? `/${this.product_id}` : ''),
                request_data = this.prepareData();
            if (this.product_id) request_data.append('_method', 'patch');
            axios.post(request_url, request_data, {
                Headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((...success_response) => {
                    // console.log(success_response);
                    let response = success_response[0];
                    let data = response.data;
                    if (data.id) {
                        this.productFormHide();
                        if (this.product_id) {
                            this.product = this.loadProduct(data);
                            this.$emit('input', data);
                            this.$emit('change', data); // this will not trigger v-model update
                        }
                        else {
                            this.$emit('product:created', data);
                            this.product = this.newProduct();
                        }
                        this.$refs.inputFile.value = '';
                    }
                })
                .catch((...error_response) => {
                    // console.log(error_response);
                    let error = error_response[0];
                    let data = error.response.data;
                    Object.keys(data.errors).forEach(field => {
                        field = field.replace('_', '-');
                        let fieldname = `product-${field}`;
                        try {
                            this.$el.querySelector(`[id="product-${field}-${this.uuid}"]`).classList.add('border-danger');
                        } catch (e) {
                            console.log(field, fieldname);
                        }
                    });
                });
        },
        fetchProduct() {
            this.dataIsLoading(true);
            axios.get(`${base_url}/admin/api/products/${this.product_id}`)
                .then(({ data }) => {
                    try {
                        this.product = this.loadProduct(data);
                    } catch (e) { console.error(e) }
                    this.dataIsLoading(false);
                })
                .catch((...error) => console.log(error));
        },
        productFormShow() {
            if (this.product_id) this.fetchProduct();
            this.$refs.productForm.modalShow();
        },
        productFormHide() {
            this.$refs.productForm.modalHide();
        },
        addField() {
            this.product.fields.push({});
        },
        fileChange(e) {
            var default_text = 'Choose file';
            if (!this.$refs.productImage) {
                return;
            }
            if (e) {
                let value = e.target.value ? e.target.value : default_text;
                this.product.image = e.target.value ? e.target.files[0] : null;
                this.$refs.productImage.innerHTML = value;
                return;
            } else {
                this.$refs.productImage.innerHTML = default_text;
                return;
            }
        },
        prepareData() {
            let tmp_product = Object.assign({}, this.product);
            if (!(tmp_product.image instanceof File)) tmp_product.image = null;
            if (tmp_product.fields.length === 0) tmp_product.fields = '';
            return translator.transDataToFormData(tmp_product);
        },
        newProduct() {
            this.fileChange();
            return {
                name: null,
                category_id: null,
                price: null,
                description: null,
                image: null,
                fields: []
            };
        },
        loadProduct(old_product) {
            let new_product = this.newProduct();
            Object.keys(new_product).forEach(key => new_product[key] = old_product[key]);
            if (new_product.fields.length) {
                new_product.fields.forEach((field, field_index) => {
                    if (field.values.length) {
                        field.values.forEach((value, value_index) => {
                            if (typeof value === 'object') field.values[value_index] = value.value;
                        });
                        new_product.fields[field_index] = field;
                    }
                });
            }
            return new_product;
        },
        removeField(index) {
            this.product.fields.splice(index, 1);
        }
    }
};

</script>
